import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { SITE } from "../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[var(--maroon-950)] text-[#F5EFE6] grain overflow-hidden">
      <div className="container-edge py-20 grid grid-cols-1 md:grid-cols-12 gap-10 relative z-10">
        <div className="md:col-span-5">
          <div className="overline text-[#D38888]">{SITE.short} · Established {SITE.established}</div>
          <h3 className="font-display text-3xl md:text-4xl mt-4 leading-tight">
            Built in Patiala. <br />
            Trusted across India's bakery floors.
          </h3>
          <p className="mt-6 text-[#E8DCC8]/80 max-w-md leading-relaxed">
            We design and manufacture the dies and rollers that quietly power some of the country's busiest biscuit and bakery lines.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-[#D38888]">Explore</div>
          <ul className="mt-5 space-y-3 text-[15px]">
            <li><Link to="/" className="hover:text-white" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/products" className="hover:text-white" data-testid="footer-link-products">Products</Link></li>
            <li><Link to="/about" className="hover:text-white" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/gallery" className="hover:text-white" data-testid="footer-link-gallery">Gallery</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline text-[#D38888]">Contact</div>
          <ul className="mt-5 space-y-4 text-[15px]">
            <li className="flex gap-3"><MapPin size={18} className="mt-0.5 text-[#D38888] shrink-0" /><span>{SITE.addressLine1}<br />{SITE.addressLine2}</span></li>
            <li className="flex gap-3"><Phone size={18} className="text-[#D38888] shrink-0" /><a data-testid="footer-phone" href={`tel:${SITE.phone.replace(/\s+/g, "")}`} className="hover:text-white">{SITE.phone}</a></li>
            <li className="flex gap-3"><Mail size={18} className="text-[#D38888] shrink-0" /><a data-testid="footer-email" href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 relative z-10">
        <div className="container-edge py-6 flex flex-col md:flex-row gap-3 justify-between text-xs text-[#E8DCC8]/60 font-mono-accent uppercase tracking-wider">
          <span>© {new Date().getFullYear()} {SITE.brand}. All rights reserved.</span>
          <span>GST: {SITE.gst} · IEC: {SITE.iec}</span>
        </div>
      </div>
    </footer>
  );
}
